import React,{Component} from 'react';

class Headers extends Component{
    render(){
        return(
            <div className = "header">{this.props.hname}
            </div>
        )
    }
}




export default Headers;


// WEBPACK FOOTER //
// ./src/Components/Headers.js